import isFinite from "lodash/isFinite";

// eslint-disable-next-line import/prefer-default-export
export const isPositiveInteger = val => isFinite(val) && val > 0;
